/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Featured1Inputs */

const zh_adminthreads_featured1 = /** @type {(inputs: Adminthreads_Featured1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选`)
};

const en_adminthreads_featured1 = /** @type {(inputs: Adminthreads_Featured1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const es_adminthreads_featured1 = /** @type {(inputs: Adminthreads_Featured1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Adminthreads_Featured1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_featured1 = /** @type {((inputs?: Adminthreads_Featured1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Featured1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_featured1(inputs)
	if (locale === "en") return en_adminthreads_featured1(inputs)
	return es_adminthreads_featured1(inputs)
});
export { adminthreads_featured1 as "adminThreads_featured" }